import { throttle } from 'throttle-debounce'

const initAccordion = () => {
  const MOBILE_BREAKPOINT = 768;

  const accordionMobileNav = () => {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      return
    }
  
    const select = document.querySelector('[data-accordion-nav-mobile]')
    if(select && window.getComputedStyle(select).display !== 'none') {
      select.addEventListener('change', (e) => { 
        select.value = e.target.value;
        const selection = select.value

        document.querySelectorAll('[data-child-index]').forEach(accordion => {
          accordion.classList.remove('active')
          accordion.classList.add('visually-hidden')
        })
        document.querySelectorAll(`[data-child-index=${selection}]`).forEach(accordion => {
          accordion.classList.remove('visually-hidden')
          accordion.classList.add('active')
        })
      })
    }
  }

  window.addEventListener('resize', throttle(333, false, () => {
    accordionMobileNav()
  }))

  if (window.innerWidth < MOBILE_BREAKPOINT) {
    accordionMobileNav()
  }
}

export default initAccordion;